import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { Constants } from '../core/Constants';
import { API_CMS_ENDPOINT, API_ENDPOINT } from '../core/DI';
import { LastSubject } from '../core/LastSubject';
import { CategoryFiltersRequestDto } from '../core/models/filter-backend';
import { GenericCardAndFiltersDtoResponse } from '../core/models/generic-card-and-filter.dto-response';
import { KitComponentsDtoResponse } from '../core/models/kit-components.dto-response';
import { MakeYearModel } from '../core/models/make-year-model.model';
import { ProductDetailsDtoResponse } from '../core/models/product-details.dto-response';
import { ProductSpecsOptions } from '../core/models/product-specs-options.model';
import { Product } from '../core/models/product.model';
import { StaggeredProductDetailsDtoResponse } from '../core/models/staggered-product-details.dto-response';
import { WheelCategoryFilter } from '../core/models/wheel-category-filter.model';
import { IProductService } from '../shared/iproduct.service';
import { PagingService } from '../shared/paging.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Helper } from './helper';
import { GenericSummaryCardDtoResponse } from 'app/core/models/generic-summary-card.dto-response';
import { KitPackage } from '../core/models/kit-package';
import { PackageBuilderModel } from '../core/models/package-builder.model';
import { StaggeredPackageBuilderModel } from '../core/models/staggered-package-builder.model';
import { CustomerFeedbackOption } from "app/core/models/customer-feedback-option";

@Injectable()
export class SearchTextService implements IProductService {
  private productsSubject = new LastSubject<GenericCardAndFiltersDtoResponse>();
  private componentsSubject = new LastSubject<KitComponentsDtoResponse>();
  private searchWithFilterInProgress = new Subject<boolean>();
  apiEndpoint: string;
  apiCmsEndpoint: string;
  KitNo: string;
  customParameter: {} = null;
  // djb:yagni-declared but not used
  private lastSearchWithoutFilterResponse: GenericCardAndFiltersDtoResponse;

  constructor(@Inject(API_ENDPOINT) apiEndpoint: string,
    @Inject(API_CMS_ENDPOINT) apiCmsEndpoint: string,
    private http: HttpClient,
    private pagingService: PagingService) {
    this.apiEndpoint = apiEndpoint;
    this.apiCmsEndpoint = apiCmsEndpoint;
  }

  get onProducts(): Observable<GenericCardAndFiltersDtoResponse> {
    return this.productsSubject.asObservable();
  }

  get onComponents(): Observable<KitComponentsDtoResponse> {
    return this.componentsSubject.asObservable();
  }

  get onSearchWithFilter(): Observable<boolean> {
    return this.searchWithFilterInProgress.asObservable();
  }

  searchWithTextAndFilter(searchText: string, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
    this.searchWithFilterInProgress.next(true);
    const api = `${this.apiEndpoint}/items/search`;
    const p: string = sessionStorage.getItem(`AnyPaging`);
    if (p != null) {
      filters.paging.page = JSON.parse(p)["page"];
      filters.paging.pageSize = JSON.parse(p)["pageSize"];
      filters.paging.orderBy = JSON.parse(p)["orderBy"];
    }
    this.http.post<GenericCardAndFiltersDtoResponse>(api, {
      baseFilter: {
        keyword: searchText
      },
      secondaryFilter: filters,
      loadSecondaryFilters: loadSecondaryFilters
    }).subscribe(productsAndFiltersDto => {

      this.productsSubject.next(productsAndFiltersDto);
      this.searchWithFilterInProgress.next(false);
    }, Helper.handleError);
  }

  searchComponents(searchText: string): void {

    this.KitNo = searchText;
    const api = `${this.apiEndpoint}/items/kitcomponents/?id=${encodeURIComponent(searchText)}`;
    
    this.http.get<KitComponentsDtoResponse>(api).subscribe(componentsDto => {

      this.componentsSubject.next(componentsDto);

    }, Helper.handleError);

  }


  getProductDetailsByVehicleAndFilterAndStyleAndFinish(carDetails: MakeYearModel, wheelStagger: string, filters: CategoryFiltersRequestDto)
    : Observable<Array<GenericSummaryCardDtoResponse>> {
    throw new Error('NotSupportedException');
  }

  getProductDetailsBySpecs(productId: string): Observable<ProductDetailsDtoResponse> {
    const api = `${this.apiEndpoint}/items/details?id=${encodeURIComponent(productId)}`;
    return this.http.get<ProductDetailsDtoResponse>(api);
  }

  getProductDetails(productId: string, carDetails: MakeYearModel, frontWheelOrTireId = '', rearWheelOrTireId = ''): Observable<ProductDetailsDtoResponse> {
    throw new Error('NotSupportedException');
  }

  getStaggeredProductDetails(productId: string, carDetails: MakeYearModel,
    frontWheelOrTireId: string, rearWheelOrTireId: string): Observable<StaggeredProductDetailsDtoResponse> {
    throw new Error('Method not implemented.');
  }

  getStaggeredProductDetailsBySpecs(productId: string): Observable<StaggeredProductDetailsDtoResponse> {
    throw new Error('Method not implemented.');
  }

  postProductToCart(id: string, qty: number, warningNotes: string[], pairNo: string, productType: string, productStyle: string = null) {
    let api = `${this.apiCmsEndpoint}/cart/AddProduct`;

    const product: Product = new Product();
    product.id = id;
    product.quantity = qty;
    product.warningNotes = warningNotes;
    product.type = productType;

    // WIP - VOLUME DISCOUNT
      if (this.customParameter !== null && this.customParameter['volumeDiscount'] !== null) {
      product.volumeDiscount = this.customParameter['volumeDiscount'];
      product.isVolumeDiscountEligible = true;
    }

    // WIP - SEASONAL CARE PLAN
    if (this.customParameter !== null && this.customParameter['scpReplaceCartContent'] !== null) {
        const _scpReplaceCartContent = this.customParameter['scpReplaceCartContent'];
        if (_scpReplaceCartContent)
            api = `${this.apiCmsEndpoint}/cart/AddProduct?scpReplaceCartContent=true`;
    }

    this.http.post(api, product).toPromise().then(response => {
      if (productStyle !== null) {
        if (productStyle.includes("Spline") || productStyle.includes("Tuner"))
          window.location.href = "/fastfinder/shop/search-by-specs/accessories/results?categoryId=90&productId=" + id;
        else
          window.location.href = "/fastfinder/shop/search-by-specs/accessories/results?categoryId=92&productId=" + id;
      }
      else
        window.location.href = Constants.SHOPPING_CART_HREF;
    }).catch((err: any) => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    });
  }

  postProductPairToCart(frontId: string, frontQty: number, frontWarningNotes: string[], rearId: string, rearQty: number, rearWarningNotes: string[], pairNo: string, productType: string) {
    throw new Error('Method not implemented.');
  }

  postKitToCart(id: string, qty: number) {

    this.KitNo = id;

    this.searchComponents(id);

    this.onComponents.subscribe(
      responseProduct => {
        if (responseProduct != null) {
          const api = `${this.apiCmsEndpoint}/cart/AddKit`;
          const kitPackage: KitPackage = new KitPackage();

          kitPackage.kitID = this.KitNo;
          kitPackage.kit = this.createProduct(id, qty, Constants.PRODUCT_TYPE_KIT, null, "", 1);
          kitPackage.package = new StaggeredPackageBuilderModel();
          kitPackage.package.front = new PackageBuilderModel();
          kitPackage.package.rear = new PackageBuilderModel();

          for (let num = 0; num < responseProduct.cards.length; num++) {
            if (responseProduct.cards[num].id != null) {

              switch (responseProduct.cards[num].itemCategoryId) {
                case 1://Accessories
                  kitPackage.package.front.hardwares.push(this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_HARDWARE, null, "", num + 2));
                  break;
                case 2://Wheels
                  kitPackage.package.front.wheel = this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_WHEEL, null, "", num + 2);
                  break;
                case 3://Tires
                  kitPackage.package.front.tire = this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_TIRE, null, "", num + 2);
                  break;
                case 4://Kits
                case 5://Services
                case 6://Other
                  continue;
                case 7://Consumables
                  kitPackage.package.front.labours.push(this.createProduct(responseProduct.cards[num].id, responseProduct.cards[num].kitQty * qty, Constants.PRODUCT_TYPE_LABOUR, null, "", num + 2));
                  break;
                default:
                  break;
              }
            }
          }

          this.http.post(api, kitPackage).toPromise().then(response => {
            window.location.href = Constants.SHOPPING_CART_HREF;
          }).catch((err: any) => {
            window.location.href = Constants.SHOPPING_CART_HREF;
          });

        }
      }, Helper.handleError);


  }

  createProduct(id: string, qty: number, productType: string, warningNotes: string[], pairNo: string, sequence: number): Product {
    return new Product({
      id: id,
      warningNotes: warningNotes,
      quantity: qty,
      type: productType, //Constants.PRODUCT_TYPE_WHEEL,
      pairNo: pairNo,
      sequence: sequence
    });
  }



  postProductsToCart(frontProduct: Product, rearProduct: Product, frontLabours: Product[], rearLabours: Product[], car: MakeYearModel) {
    throw new Error('NotSupportedException');
  }

  postToCartWithCar(frontId: string, frontQty: number, rearId: string, rearQty: number, frontWarningNotes: string[], rearWarningNotes: string[], car: MakeYearModel, pairNo: string) {
    throw new Error('NotSupportedException');
  }

  getProductFilters(): Observable<ProductSpecsOptions[]> {
    throw new Error('NotSupportedException');
  }

  getProductByBrandFilters(): Observable<ProductSpecsOptions[]> {
    throw new Error('NotSupportedException');
  }

  getProductsByVehicleAndFilter(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
    throw new Error('NotSupportedException');
  }

  getProductsByVehicleAndFilterForWheel(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto,
    loadSecondaryFilters: boolean, frontWheelId: string, rearWheelId: string,
    frontWheelQty: number, rearWheelQty: number, frontOffset?: number, rearOffset?: number)
    : void {
    throw new Error('NotSupportedException');
  }
  getProductsByVehicleAndFilterForTire(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto,
    loadSecondaryFilters: boolean, frontTireId: string, rearTireId: string, frontTireQty: number, rearTireQty: number): void {
    throw new Error('NotSupportedException');
  }
  getProductsByVehicleAndFilterForAccessory(wheelCategoryFilter: WheelCategoryFilter,
    filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
    throw new Error('NotSupportedException');
  }

  getProductsBySpecsAndFilter(wheelCategoryFilter: WheelCategoryFilter, filters: CategoryFiltersRequestDto): void {
    throw new Error('NotSupportedException');
  }

  getCategoryFiltersFromRoute(params: ParamMap): WheelCategoryFilter {
    throw new Error('NotSupportedException');
  }

  getPlacardToolKits(): Observable<any> {
    throw new Error('NotSupportedException');
  }

  getPlacardToolKitVehicles(kitNo: string): Observable<any> {
    throw new Error('NotSupportedException');
  }

  getPlacardToolPSIs(vehicleOptionID: number, tire: string, rearRire: string): Observable<any> {
    throw new Error('NotSupportedException');
  }

    submitCustomerFeedback(params: ParamMap, comments: string, categoryId: number, departmentResponsible: string, itemNo: string, customerFeedbackOptionId: string) {
        const api = `${this.apiCmsEndpoint}/angular/send/customerfeedback`;
        const makeYearModel = Helper.extractMakeYearModelFromRouteParam(params);
        const data = {
            makeYearModel: makeYearModel,
            comments: comments,
            categoryId: categoryId,
            departmentResponsible: departmentResponsible,
            itemNo: itemNo,
            customerFeedbackOptionId: customerFeedbackOptionId
        };

        return this.http.post(api, data).toPromise();
    }

    getCustomerFeedbackOptions(): Observable<CustomerFeedbackOption[]> {
        const api = `${this.apiCmsEndpoint}/angular/customerfeedbackoption`;

        return this.http.get<CustomerFeedbackOption[]>(api);
    }
}
